const MIN_DISTANCE_PX = 60;
const MAX_MS = 600;

export interface SwipeTrack {
  dx: number;
  dy: number;
  ms: number;
}

/** A quick sideways flick: left goes on to the next scene, right goes back. */
export function swipeDirection({ dx, dy, ms }: SwipeTrack): -1 | 1 | null {
  if (ms > MAX_MS || Math.abs(dx) < MIN_DISTANCE_PX || Math.abs(dx) < Math.abs(dy) * 2) {
    return null;
  }
  return dx < 0 ? 1 : -1;
}
